import { Box } from '@mui/material'
import { useMemo } from 'react'
import styles from './ThreadListRow.module.scss'
import { getThreadMenuItems } from './threadRowMenuConfig'
import { useThreadListRowRename } from './useThreadListRowRename.js'
import ThreadListRowTitleEdit from './ThreadListRowTitleEdit.jsx'
import ThreadListRowTitleButton from './ThreadListRowTitleButton.jsx'
import ThreadListRowKebabMenu from './ThreadListRowKebabMenu.jsx'



export default function ThreadListRow(props) {
  const {
    title,
    onClick,
    active = false,
    onMenuClick,
    thread,
    onThreadMenuAction,
    onRenameThread,
    menuSurface = 'threads',
    showNoteIcon = false,
    showChatIcon: showChatIconProp,
    showFolderIcon = false,
    LeadingIcon,
    density = 'default',
    plain = false,
  } = props

  const menuItems = useMemo(() => getThreadMenuItems(menuSurface), [menuSurface])
  const rename = useThreadListRowRename({ title, thread, onRenameThread })
  const showChatIcon =
    showChatIconProp ??
    (Boolean(thread) && !showNoteIcon && !showFolderIcon && !LeadingIcon && density !== 'compact')

  return (
    <Box
      className={[
        styles.rowShell,
        active ? styles.active : '',
        density === 'compact' ? styles.rowShellCompact : '',
        plain ? styles.rowShellPlain : '',
      ]
        .filter(Boolean)
        .join(' ')}
    >
      {rename.isEditingTitle ? (
        <ThreadListRowTitleEdit {...rename} />
      ) : (
        <ThreadListRowTitleButton
          title={title}
          thread={thread}
          active={active}
          onClick={onClick}
          showNoteIcon={showNoteIcon}
          showChatIcon={showChatIcon}
          showFolderIcon={showFolderIcon}
          LeadingIcon={LeadingIcon}
          density={density}
        />
      )}
      {thread ? (
        <ThreadListRowKebabMenu
          menuItems={menuItems}
          isEditingTitle={rename.isEditingTitle}
          onMenuClick={onMenuClick}
          onMenuItemSelect={rename.handleMenuItemSelect}
          onThreadMenuAction={onThreadMenuAction}
          thread={thread}
        />
      ) : null}
    </Box>
  )
}
